
import React from 'react' 
import CardDisplay from '../../components/CardDisplay/CardDisplay'
import Button from '../../components/Button/Button'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';
import { transactions } from '../../testdata/transactions';
import u274 from '../../images/accounts/u274.png'
import u275 from '../../images/accounts/u275.png' 
import u147 from '../../images/accounts-management/u147.png'

import TransactionCard from '../../components/TransactionCard/TransactionCard';
import PageNavigator from '../../components/PageNavigator/PageNavigator';
import TabButton from '../../components/TabButton/TabButton';
import CardholderInfoCard from '../../components/CardholderInfoCard/CarholderInfoCard';
import ClaimTable from '../../components/ClaimTable/ClaimTable';


export default class AccountDetails extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
           //transaction page handling
           pagerIndex:0,

           //cards
           card3_active:true,

           //reimbursements placeholder data
           reimbursements:[
            {title:'form-123.pdf', description:'Lorem Ipsum Dolor Adipising Amin Consequiter...',method:'ACH',updated:'Jan 12,2023',status:'Paid'},
            {title:'form-123456.pdf', description:'Lorem Ipsum Dolor Adipising Amin Consequiter...',method:'Pay Provider',updated:'Jul 11,2023',status:'Pending'},
            {title:'form-123.pdf', description:'Lorem Ipsum Dolor Adipising Amin Consequiter...',method:'ACH',updated:'Nov 27,2023',status:'In Process'},
            {title:'form-123.pdf', description:'Lorem Ipsum Dolor Adipising Amin Consequiter...',method:'ACH',updated:'Jun 07,2024',status:'In Process'},
           ]
        }
    }
    
    componentDidMount=()=>{
        this.setState({maxIndex:Math.ceil(transactions.length/9)})
    }
    navLeft=()=>{
        const {pagerIndex}=this.state
        if(pagerIndex===0)
            return
        this.setState({pagerIndex:pagerIndex-1})
    }
    navRight=()=>{
        const pagerIndex=this.state.pagerIndex
        const maxIndex=this.state.maxIndex
        if(pagerIndex===maxIndex-1)
            return
        this.setState({pagerIndex:pagerIndex+1})
        //alert(this.state.pagerIndex)
    }

    renderTransactions=()=>{
        const transactionList = transactions;
        var minIndex=this.state.pagerIndex*9
        var maxIndex=minIndex+9<transactionList.length?minIndex+9:transactionList.length //renders next nine
        const reducedArray=transactionList.slice(minIndex,maxIndex)
        
        return(
            <div>
           { reducedArray.map((item, index)=><TransactionCard key={index} status={item.status} action={item.action} type={item.type} date={item.date} provider={item.provider} accNumber={item.account} service={item.service} amount={item.amount}/>)}
           </div>
        )
    }

    renderContentView=()=>{
        switch(this.state.content_mode){
            case "cardholder":
                return(
                    <div >
                        <CardholderInfoCard primary firstname="John" lastname='Doe' status={true} dob='02/11/1972' ssn='123456789' address='46 Lac Ave' city='North Brunswick' state='NJ' zip='08815' Country='United States' email='johndoe@mydomain.com' phone='732-345-5432' workphone='888-543-2134' />
                        <CardholderInfoCard  relationship='Spouse' firstname="Jane" lastname='Doe' status={true} dob='05/25/1973' ssn='123459098' address='46 Lac Ave' city='North Brunswick' state='NJ' zip='08815' country='United States' email='misses_doe@mydomain.com' phone='732-345-1890' />
                    </div>
                )
            case "cards":
                return (
                <div style={{background:"#FFF",width:"46.3vw",height:'auto', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                    <div style={{display:'flex', justifyContent:'space-between',marginTop:'1vh',marginBottom:'3vh'}} ><span style={{...Fonts.supertitle, color:Colors.black}}>My Active Cards</span> <div><Button title='+ Add Card' width='7vw' height='3vh'/></div></div>
                    <CardDisplay status={this.state.card3_active} onClick={()=>{this.setState({card2_active:!this.state.card2_active})}} name={'John Doe'} card_number='**** **** **** 2231' expiration='08/2025' cvv='***'/>
                    <div style={{display:'flex',backgroundColor:Colors.grey,height:1,marginTop:'3vh',marginBottom:'3vh'}}/>{/**divider */}
                    <CardDisplay status={this.state.card1_active} onClick={()=>{this.setState({card1_active:!this.state.card1_active})}} name={'Jane Doe'} card_number='**** **** **** 1234' expiration='04/2024' cvv='***'/>
                    <div style={{display:'flex',backgroundColor:Colors.grey,height:1,marginTop:'3vh',marginBottom:'3vh'}}/>{/**divider */}
                    <CardDisplay status={this.state.card2_active} onClick={()=>{this.setState({card3_active:!this.state.card2_active})}} name={'Sussy Doe'} card_number='**** **** **** 2231' expiration='08/2025' cvv='***'/>
                    <div style={{display:'flex',height:'7vh'}}/>{/**divider */}
                </div>
                )
            case "claims":
                return(
                    <div style={{background:"#FFF",width:"46.3vw",height:'auto', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                        <div style={{display:'flex', justifyContent:'space-between',marginTop:'1vh',marginBottom:'3vh'}} ><span style={{...Fonts.subtitle}}>Claimns</span></div>
                        <div style={{display:'flex',flexDirection:'row',marginTop:'3vh',marginBottom:'-1vh'}}> {/* Sort Filters */}
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'7.8vw',marginLeft:'2vw'}}>
                                <span style={{...Fonts.faded_label}}>Status</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'5vw'}}>
                                <span style={{...Fonts.faded_label}}>Action</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'6.6vw'}}>
                                <span style={{...Fonts.faded_label}}>Type</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'17.8vw'}}>
                                <span style={{...Fonts.faded_label}}>Transaction Date</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                                <span style={{...Fonts.faded_label}}>Amount</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                        </div>
                        <div style={{display:'flex',flexDirection:"column",height:'100vh',marginBottom:'-3vh'}}>{/* Transaction Container */}
                            {this.renderTransactions()}
                        </div>
                        <PageNavigator index={this.state.pagerIndex+1} length={this.state.maxIndex} navLeft={this.navLeft} navRight={this.navRight} />
                        <div style={{height:'4vh'}}/>
                    </div>
                )
            case "reimburesements":
                return(
                    <div style={{background:"#FFF",width:"46.3vw",height:'auto',minHeight:'50vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                        <div style={{display:'flex', justifyContent:'space-between',marginTop:'1vh',marginBottom:'2vh'}} ><span style={{...Fonts.supertitle, color:Colors.black}}>Expenses Submitted</span><Button title='New Claim' width='7vw' /></div>
                        <div style={{backgroundColor:Colors.grey,height:2, width:'46vw',marginBottom:'2vh'}}/>
                        <ClaimTable reimburesements={this.state.reimbursements} />
                        <div style={{height:'5vh'}}/>
                    </div>
                )
            default:
                return(
                    <div >
                        <CardholderInfoCard primary firstname="John" lastname='Doe' status={true} dob='02/11/1972' ssn='123456789' address='46 Lac Ave' city='North Brunswick' state='NJ' zip='08815' country='United States' email='johndoe@mydomain.com' phone='732-345-5432' workphone='888-543-2134' />
                        <CardholderInfoCard  relationship='Spouse' firstname="Jane" lastname='Doe' status={true} dob='05/25/1973' ssn='123459098' address='46 Lac Ave' city='North Brunswick' state='NJ' zip='08815' country='United States' email='misses_doe@mydomain.com' phone='732-345-1890' />
                    </div>
                )
        }
    }

    render(){
        return (
        <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:"48vw"}}>{/**Title*/}
                <span style={{...Fonts.supertitle,color:"#003F97"}}><span style={{color:Colors.black}}>Manage Accounts / </span>Account Details</span><img onClick={this.props.goBack} alt='u147' style={{width:'1vw',height:'1vw', cursor:'pointer'}} src={u147}/>
            </div>
            <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between',width:'32vw', marginTop:"1.7vh"}}>
                <TabButton onClick={()=>this.setState({content_mode:'cardholder'})} title='Cardholder info' width='7vw' height='3.5vh' selected={!this.state.content_mode||this.state.content_mode==="cardholder"} />
                <TabButton onClick={()=>this.setState({content_mode:'cards'})} title='Card Detail' width='7vw' height='3.5vh' selected={this.state.content_mode==="cards"} />
                <TabButton onClick={()=>this.setState({content_mode:'claims'})} title='Claims Activity' width='7vw' height='3.5vh' selected={this.state.content_mode==="claims"} />
                <TabButton onClick={()=>this.setState({content_mode:'reimburesements'})} title='Reimburesements' width='7vw' height='3.5vh' selected={this.state.content_mode==="reimburesements"} />
            </div>
            {this.renderContentView()}
        </div>
    )}
}


